import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import MeetingData from 'components/brandActivation/viewDetails/meetingData/meetingData';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import TableSection from 'components/sales/tableSection/tableSection';


const FeedbackDetail = ({
  getFeedbackById,
  feedbackById,
  match,
  history,
}) => {
  const [details, setDetails] = useState(null);
  const [poc, setPoc] = useState([]);
  const [othersEmail, setOthersEmail] = useState([]);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    'Question',
    'Feedback',
  ];

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getFeedbackById(match?.params?.id);
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    const tableData = [
      'id',
      'question',
      'feedback',      
    ];
    if (feedbackById && feedbackById.resultSets) {
    const data = feedbackById.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] }))
        )
      );
      console.log(data);
      if(data){
        setListData(data);
      }else{
        setListData([]);   
      }
    
   
    setPageCount(Math.ceil(feedbackById.total / feedbackById.per_page));
  }
  }, [feedbackById]);

  const handleModalHide = () => setIsModal(false);

  const handleCancelModalHide = () => {
    setIsCancelModal(false);
    history.goBack();
  };

 


  const headerBtns = () => {
    return (
      <Fragment>
        
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getFeedbackById(filter, val.selected + 1);
    setIsLoading(false);
  };
  return (
    <Layout
    title={localization.feedBack}
  //   Buttons={headerBtns}
    isGoback
    isLoading={isLoading}
    linkUrl={`${baseUrl}/brand-activation/sites-listing`}
  >
    {/* <TableSection
      data={listData}
      headers={Headers}
      detailList={meetingList}
      isId={false}
    /> */}
     <TableSection
      data={listData}
      isId={false}
      headers={Headers}
      pageCount={pageCount}
      onPageChange={onPageChange}
      srNo={feedbackById?.from}
      // detailList={meetingList}
    />
     {/* <ListFilters
      showFilter={showFilter}
      filterToggle={filterToggle}
      applyFilter={(val) => applyFilter(val)}
      statusId={'1,2,3'}
      listFilterData={siteFilters ? siteFilters : null}
      meetingFilter
    /> */}
  </Layout>
  );
};

export default FeedbackDetail;
